// extracted by mini-css-extract-plugin
export default {"toggle":"TimePeriodToggle_toggle__+p05Y"};